import RangePickerDays from './range-picker-days';

export default RangePickerDays;
